import { produce } from 'immer';

import {
    ELEMENT_CHIP_EDITING_FINISH,
    ELEMENT_CHIP_EDITING_START,
    ELEMENT_CHIP_SELECT,
    type ElementChipsAction,
} from './elementChipsActions';
import type { ElementChipSelection } from './elementChipsTypes';

export type ElementChipsState = {
    selectedChip: ElementChipSelection | null;
    editingChip: ElementChipSelection | null;
};

const initialState: ElementChipsState = {
    selectedChip: null,
    editingChip: null,
};

/**
 * Returns whether two chip selections identify the same visible chip.
 */
const areElementChipSelectionsEqual = (
    first: ElementChipSelection | null,
    second: ElementChipSelection | null,
): boolean =>
    first?.containerId === second?.containerId &&
    first?.elementId === second?.elementId &&
    first?.chip.id === second?.chip.id;

/**
 * Stores transient generic chip selection state for toolbar-level consumers.
 */
const elementChipsReducer = (state = initialState, action: ElementChipsAction): ElementChipsState => {
    switch (action.type) {
        case ELEMENT_CHIP_SELECT:
            return produce(initialState, (draft) => {
                draft.selectedChip = action.chipSelection;
                draft.editingChip = null;
            });
        case ELEMENT_CHIP_EDITING_START:
            return produce(state, (draft) => {
                draft.selectedChip = action.chipSelection;
                draft.editingChip = action.chipSelection;
            });
        case ELEMENT_CHIP_EDITING_FINISH:
            return produce(state, (draft) => {
                if (areElementChipSelectionsEqual(draft.editingChip, action.chipSelection)) draft.editingChip = null;
            });
        default:
            return state;
    }
};

export default elementChipsReducer;
